import React from 'react'
import { Box, TextField, Typography, CircularProgress} from "@mui/material";
import { useState } from "react";
import { ColorModeContext, useMode } from "../theme";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { Topbar } from '../layouts/Topbar';
import Sidebarr from '../layouts/Sidebar';
import Grid from '@mui/material/Grid';
import Header from "../components/Header";
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import Button from '@mui/material/Button';
import { api } from '../api';
import { fetchToken } from '../auth/Token';
import Snackbar from '@mui/material/Snackbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { useFormik, validateYupSchema } from 'formik';
import * as Yup from 'yup';
import { MdCloudUpload, MdDelete } from 'react-icons/md';
import { AiFillFileImage } from 'react-icons/ai';
import '../components/images.css';
import { List,ListItem, ListItemText} from '@mui/material';
import Alert from '@mui/material/Alert';
import { toast } from 'sonner';




export const CreateMember = () => {
    const [theme, colorMode] = useMode();
    const [isSidebar, setIsSidebar] = useState(true);
    const [image, setImage] = useState(null)
    const [fileName, setFileName] = useState("No selected file")
    const [imag, setImag] = useState(null)
    const [fileNam, setFileNam] = useState("No selected file")
    const [alert, setAlert] = useState()
    const [loading, setLoading] = useState(false);

    const handleFileChange = (event) => {
        const file = event.currentTarget.files[0];
        if (file) {
            setFileName(file.name);
            setImage(URL.createObjectURL(file));
            formik.setFieldValue("memberImage", file);
        }
    };

    const handleFileChang = (event) => {
        const file = event.target.files[0];
        if (file) {
            setFileNam(file.name);
            setImag(URL.createObjectURL(file));
            formik.setFieldValue("ghCardImage", file);
        }
    };



    const formik = useFormik({
      initialValues: {
        firstname:'',
        middlename:'',
        lastname:'',
        otherName:'',
        commonname:'',
        dob:'2023-01-02',
        gender:'',
        ghCardNumber:'',
        memberImage:null,
        phone:'',
        otherPhone:'',
        address:'',
        otherAddress:'',
        nextOfKin:'',
        ghCardImage:null,
        MaritalStatus:'',
        EducationLevel:'',
        Town:'',
        ruralOrUrban:'',
      },
      validationSchema: Yup.object({
        firstname: Yup.string()
          .required('First name is required'),
        gender: Yup.string()
          .required("Must Specify Gender"),
        ghCardNumber: Yup.string()
          .matches(/^GHA-\d{9}-\d$/, 'Invalid Ghana Card number format. It should be in the format GHA-XXXXXXXXX-X').nullable(),
      }),
      onSubmit: (values) => {
          setLoading(true)
          const data = new FormData();
          data.append('firstname', values.firstname)
          data.append('middlename', values.middlename === null? '':values.middlename)
          data.append('lastname', values.lastname === null? '':values.lastname)
          data.append('otherName', values.otherName === null? '':values.otherName)
          data.append('commonname', values.commonname === null? '':values.commonname)
          data.append('dob', values.dob === null? '': values.dob)
          data.append('gender', values.gender  === null? '': values.gender)
          data.append('ghCardNumber', values.ghCardNumber === null? null: values.ghCardNumber)
          data.append('memberImage', values.memberImage)
          data.append('phone', values.phone  === null? '':values.phone )
          data.append('otherPhone', values.otherPhone === null? '':values.otherPhone)
          data.append('address', values.address === null? '':values.address)
          data.append('otherAddress', values.otherAddress  === null? '':values.otherAddress)
          data.append('nextOfKin', values.nextOfKin === null? '' : values.nextOfKin)
          data.append('ghCardImage', values.ghCardImage)
          data.append('MaritalStatus', values.MaritalStatus === null? '': values.MaritalStatus)
          data.append('EducationLevel', values.EducationLevel === null? '': values.EducationLevel)
          data.append('Town', values.Town === null? '': values.Town)
          data.append('ruralOrUrban', values.ruralOrUrban === null? '' : values.ruralOrUrban)
            api.post('/members/register/individual', data,{
              headers: {
                Authorization: 'Bearer ' + fetchToken(),
                'Content-Type': 'multipart/form-data',
              },
            }).then(function (response){
              toast.success(response.data)
              formik.handleReset()
              setAlert()
            }).catch(function (error) {
                toast.error(error.response.data.detail)
            }).finally(function (){
                setLoading(false)
            })
      }
    });


  return (
      <div className="app">
        <main className="content">
            <Box sx={{m:5}}>
              {/* HEADER */}
              <Box display="flex" justifyContent="space-between" alignItems="center">
              <Header title="Members" subtitle="Add a new Member" />
              </Box>
                <Box >
                    <Box mr={50} style={{ borderRadius:"20px", color: "#09101f", boxShadow:"15px", padding: "25px"}}>
                        <Typography mb={3} variant="h5" gutterBottom>
                            Fill Member Details
                        </Typography>
                        <Typography mb={3} variant="h5" gutterBottom>
                            {alert}
                        </Typography>
                        <form onSubmit={formik.handleSubmit}>
                        <Grid container sx={{ padding: '20px' }}>
                                <Grid item sx={{ mb:'10px' }} xs={12}>
                                    <TextField
                                        name="firstname"
                                        id="firstname"
                                        label="First name"
                                        variant="outlined"
                                        type="text"
                                        fullWidth
                                        size="small"
                                        value={formik.values.firstname}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        error={formik.touched.firstname && Boolean(formik.errors.firstname)}
                                        helperText={formik.touched.firstname && formik.errors.firstname}
                                    />
                                </Grid>
                                <Grid item sx={{ mb:'10px' }} xs={12}>
                                    <TextField
                                        name="middlename"
                                        id="middlename"
                                        label="Middlename"
                                        variant="outlined"
                                        size='small'
                                        type="text"
                                        fullWidth                
                                        value={formik.values.middlename}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                </Grid>
                                <Grid item sx={{ mb:'10px' }} xs={12}>
                                    <TextField
                                        name="lastname"
                                        id="lastname"
                                        label="Last name"
                                        variant="outlined"
                                        size="small"
                                        type="text"
                                        fullWidth
                                        value={formik.values.lastname}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                </Grid>
                                <Grid item sx={{ mb:'10px' }} xs={12}>
                                    <TextField
                                        name="otherName"
                                        id="otherName"
                                        label="Other name"
                                        variant="outlined"
                                        size="small"
                                        type="text"
                                        fullWidth
                                        value={formik.values.otherName}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                </Grid>
                                <Grid item sx={{ mb:'10px' }} xs={12}>
                                    <TextField
                                        name="commonname"
                                        id="commonname"
                                        label="Common name"
                                        variant="outlined"
                                        size="small"
                                        type="text"
                                        fullWidth
                                        value={formik.values.commonname}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                </Grid>
                                <Grid item sx={{ mb:'10px' }} xs={12}>
                                    <TextField
                                        name="dob"
                                        id="dob"
                                        label="Date of Birth"
                                        variant="outlined"
                                        size="small"
                                        type="date"
                                        fullWidth
                                        value={formik.values.dob}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                </Grid>
                                <Grid item sx={{ mb:'10px' }} xs={12}>
                                    <p>Gender</p>
                                    <Select
                                    name="gender"
                                    id="gender"
                                    label="Gender"
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                    value={formik.values.gender}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.gender && Boolean(formik.errors.gender)}
                                    helperText={formik.touched.gender && formik.errors.gender}
                                    
                                    >
                                        <MenuItem value="male">Male</MenuItem>
                                        <MenuItem value="female">Female</MenuItem> 
                                    </Select>
                                </Grid>
                                <Grid item sx={{ mb:'10px' }} xs={12}>
                                    <TextField
                                        name="ghCardNumber"
                                        id="ghCardNumber"
                                        label="Ghana Card Number"
                                        variant="outlined"
                                        size="small"
                                        type="text"
                                        fullWidth
                                        value={formik.values.ghCardNumber}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        error={formik.touched.ghCardNumber && Boolean(formik.errors.ghCardNumber)}
                                        helperText={formik.touched.ghCardNumber && formik.errors.ghCardNumber}
                                    />
                                </Grid>
                                <Grid item sx={{ mb:'10px' }} xs={12}>
                                <div className="form">
                                <input
                                        name="memberImage"
                                        id="memberImage"
                                        type="file"
                                        accept="image/*"
                                        className="input-field"
                                        onChange={handleFileChange}
                                    />
                                    <FormHelperText sx={{ color:'darkblue'}}>Member Image Here</FormHelperText>

                                    {image ? (
                                    <img src={image} width={150} height={150} alt={fileName} />
                                    ) : (
                                    <>
                                        <MdCloudUpload color="#1475cf" size={60} />
                                        <p>Browse Files to upload Member Photo</p>
                                    </>
                                    )}

                                    <section className="uploaded-row">
                                    <AiFillFileImage color="#1475cf" />
                                    <span className="upload-content">
                                        {fileName} --
                                        <MdDelete
                                        onClick={() => {
                                            setFileName("No selected File");
                                            setImage(null);
                                            formik.setFieldValue("ghCardImage", null);
                                        }}
                                        />
                                    </span>
                                    </section>
                            </div>
                            </Grid>
                            <Grid item sx={{ mb:'10px' }} xs={12}>
                                <TextField
                                    name="phone"
                                    id="phone"
                                    label="Phone Contact"
                                    variant="outlined"
                                    type="text"
                                    fullWidth
                                    size="small"
                                    value={formik.values.phone}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                />
                            </Grid>
                            <Grid item sx={{ mb:'10px' }} xs={12}>
                                <TextField
                                    name="otherPhone"
                                    id="otherPhone"
                                    label="otherPhone"
                                    variant="outlined"
                                    size='small'
                                    type="text"
                                    fullWidth
                                    onChange={formik.handleChange}
                                    value={formik.values.otherPhone}
                                    onBlur={formik.handleBlur}
                                />
                            </Grid>
                            <Grid item sx={{ mb:'10px' }} xs={12}>
                                <TextField
                                    name="address"
                                    id="address"
                                    label="Address"
                                    variant="outlined"
                                    size="small"
                                    type="text"
                                    fullWidth
                                    value={formik.values.address}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                />
                            </Grid>
                            <Grid item sx={{ mb:'10px' }} xs={12}>
                                <TextField
                                    name="otherAddress"
                                    id="otherAddress"
                                    label="Home Address(GPS link)"
                                    variant="outlined"
                                    size='small'
                                    type="text"
                                    fullWidth
                                    onChange={formik.handleChange}
                                    value={formik.values.otherAddress}
                                    onBlur={formik.handleBlur}
                                />
                            </Grid>
                            {formik.errors.submit && (
                            <Grid item sx={{ mb:'10px' }} xs={12}>
                                <FormHelperText error>
                                {formik.errors.submit}
                                </FormHelperText>
                            </Grid>
                            )}
                        </Grid>
                        <Grid item sx={{ mb:'10px' }} xs={12}>
                <TextField
                    name="nextOfKin"
                    id="nextOfKin"
                    label="Next of Kin"
                    variant="outlined"
                    type="text"
                    fullWidth
                    size="small"
                    value={formik.values.nextOfKin}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                />
            </Grid>
            <Grid item sx={{ mb:'10px' }} xs={12}>
                <div className="form">
                    <input
                        name="ghCardImage"
                        id="ghCardImage"
                        type="file"
                        accept="image/*"
                        className="input-field"
                        onChange={handleFileChang}
                    />
                    <FormHelperText sx={{ color:'darkblue'}}>Ghana Card Image Here</FormHelperText>

                    {image ? (
                    <img src={imag} width={150} height={150} alt={fileNam} />
                    ) : (
                    <>
                        <MdCloudUpload color="#1475cf" size={60} />
                        <p>Browse Files to upload Ghana Card Photo</p>
                    </>
                    )}

                    <section className="uploaded-row">
                    <AiFillFileImage color="#1475cf" />
                    <span className="upload-content">
                        {fileNam} --
                        <MdDelete
                        onClick={() => {
                            setFileNam("No selected File");
                            setImag(null);
                            formik.setFieldValue("ghCardImage", null);
                        }}
                        />
                    </span>
                    </section>
            </div>
            </Grid>
            <Grid item sx={{ mb:'10px' }} xs={12}>
                <p>Marital Status</p>
                <Select
                    name="MaritalStatus"
                    id="MaritalStatus"
                    label="Marital Status"
                    variant="outlined"
                    size="small"
                    fullWidth
                    value={formik.values.MaritalStatus}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                >
                    <MenuItem value="married">Married</MenuItem>
                    <MenuItem value="single">Single</MenuItem>
                    <MenuItem value="divorced">Divorced</MenuItem>
                    <MenuItem value="widowed">Widowed</MenuItem>
                </Select>
            </Grid>
            <Grid item sx={{ mb:'10px' }} xs={12}>
             <p>Education Level</p>
                <Select
                    name="EducationLevel"
                    id="EducationLevel"
                    label="Education Level"
                    variant="outlined"
                    size="small"
                    fullWidth
                    value={formik.values.EducationLevel}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                >
                <MenuItem value="no_school">No School</MenuItem>
                <MenuItem value="kindergarten">Kindergarten</MenuItem>
                <MenuItem value="primary_school">Primary School</MenuItem>
                <MenuItem value="jhs_school">Junior High School</MenuItem>
                <MenuItem value="high_school">Senior High School</MenuItem>
                <MenuItem value="high_school">University</MenuItem>
                <MenuItem value="vocational">Vocational/Trade School</MenuItem>
                <MenuItem value="certificate">Certificate Program</MenuItem>
                <MenuItem value="bachelor_degree">Bachelor's Degree</MenuItem>
                <MenuItem value="master_degree">Master's Degree</MenuItem>
                <MenuItem value="doctoral_degree">Doctoral Degree</MenuItem>
                <MenuItem value="post_doctoral">Post-Doctoral</MenuItem>

                </Select>
            </Grid>
            <Grid item sx={{ mb:'10px' }} xs={12}>
                <TextField
                    name="Town"
                    id="Town"
                    label="Town/City"
                    variant="outlined"
                    type="text"
                    fullWidth
                    size="small"
                    value={formik.values.Town}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                />
            </Grid>
            <Grid item sx={{ mb:'10px' }} xs={12}>
                <p>Area Type</p>
                <Select
                    name="ruralOrUrban"
                    id="ruralOrUrban"
                    label="Area Status"
                    variant="outlined"
                    size="small"
                    fullWidth
                    value={formik.values.ruralOrUrban}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                >
                    <MenuItem value="rural_area">Rural Area</MenuItem>
                    <MenuItem value="urban_area">Urban Area</MenuItem>
                </Select>
            </Grid>
            {/* {formik.errors.submit && (
                <Grid item sx={{ mb:'10px' }} xs={12}>
                <FormHelperText error>
                    {formik.errors.submit}
                </FormHelperText>
                </Grid>
            )} */}
            <Grid item sx={{ mb:'10px' }} xs={12}>
            <>
                    <Typography variant="overline" >
                    Personal Information
                    </Typography>
                    <List>
                    <ListItem>
                        <ListItemText
                        primary="First Name"
                        secondary={formik.values.firstname}
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemText
                        primary="Middle Name"
                        secondary={formik.values.middlename}
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemText
                        primary="Last Name"
                        secondary={formik.values.lastname}
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemText
                        primary="Date of Birth"
                        secondary={formik.values.dob}
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemText
                        primary="Gender"
                        secondary={formik.values.gender}
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemText
                        primary="Other Name"
                        secondary={formik.values.otherName}
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemText
                        primary="Common Name"
                        secondary={formik.values.commonname}
                        />
                    </ListItem>
                    </List>
                    <Typography variant="overline">
                    Address Information
                    </Typography>
                    <List>
                    <ListItem>
                        <ListItemText
                        primary="Phone Contact"
                        secondary={formik.values.phone}
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemText
                        primary="other Phone"
                        secondary={formik.values.otherPhone}
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemText
                        primary="Address"
                        secondary={formik.values.address}
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemText
                        primary="other Address"
                        secondary={formik.values.otherAddress}
                        />
                    </ListItem>
                    </List>
                    <Typography variant="overline">
                    More Information
                    </Typography>
                    <List>
                    <ListItem>
                        <ListItemText
                        primary="Next of Kin"
                        secondary={formik.values.nextOfKin}
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemText
                        primary="Marital Status"
                        secondary={formik.values.MaritalStatus}
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemText
                        primary="Education Level"
                        secondary={formik.values.EducationLevel}
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemText
                        primary="Town/City"
                        secondary={formik.values.Town}
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemText
                        primary="Address Type"
                        secondary={formik.values.ruralOrUrban}
                        />
                    </ListItem>
                    </List>
                    </>
                </Grid>
                <Button
                    variant='contained'
                    type='submit'
                    color='success'
                    size='small'
                    sx={{ mt:1 }}
                >
                    {
                        loading === true ?
                        <Box sx={{ width: '100%' }}>
                            <CircularProgress />
                        </Box>
                        : "Register"
                    }
                </Button>
                        </form>
                        </Box>
                    </Box>
              </Box>
          </main>
            </div>
  )
}